import { rem } from '@mantine/core'

export default {
  'portrait-handset-md': rem(360),
  'portrait-handset-lg': rem(400),
  'portrait-handset-xl': rem(480),
  'portrait-tablet-sm': rem(600),
  'portrait-tablet-lg': rem(720),
  'landscape-handset-sm': rem(480),
  'landscape-handset-md': rem(600),
  'landscape-handset-lg': rem(720),
  'landscape-handset-xl': rem(840),
  'landscape-tablet-sm': rem(960),
  'landscape-tablet-lg': rem(1024),
  'xs-8-col': rem(480),
  'sm-8-col': rem(600),
  sm: rem(840),
  md: rem(960),
  lg: rem(1280),
  xl: rem(1440),
  xxl: rem(1600),
  xxxl: rem(1920)
}
